
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import {
  Controlador as Model,
  ControladorInterfaz
} from "../../../controlador";
import * as Pedidos from "@/__env/lib/Ventas/Pedidos";
import _ from "lodash";
import { Pedido } from "@/__env/lib/Ventas/Pedidos";
import { Utiles } from "@/__env/pluggins/event-bus";
import { Wait } from "@/__env/ext";
import { Envio } from "@/__env/lib/Ventas/Envios";
@Component({
  name: "Componente",
  props: {},
  components: {}
})
export default class Componente extends Vue {
  @Prop()
  public Controlador: ControladorInterfaz;
  public get Pedido() {
    return this.Controlador.Pedido;
  }
  public get Envio() {
    return this.Controlador.Pedido.Envio;
  }
  public get Estado() {
    return this.Controlador.Vista.Estado;
  }

  public Cargando: boolean = false;
  public get Ok(): boolean {
    return (
      this.Envio &&
      (this.Envio.Tipo.esMercadoEnviosOFlex ||
        this.Pedido.Tipo.esGarbarino ||
        this.Envio.Tipo.esTreggo ||
        this.Envio.Tipo.esPickit ||
        this.Envio.Tipo.esEnvioPack)
    );
  }

  public async Ejecutar() {
    this.Cargando = true;
    await Envio.AbrirEtiqueta(this.Pedido);
    this.Cargando = false;
  }
}
